import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Bill } from 'src/app/models/bill.model';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalEditGasMeterReadComponent } from '../modals/modal-edit-gas-meter-read.component';

@Component({
  selector: 'app-receipt-reads',
  template: `
    <h5>Detalle de las lecturas</h5>
    
    <div class="d-flex" *ngFor="let prev_bill_item of prev_bill?.bill_items">
      <div class="mt-3" style="width: 160px;" *ngIf="prev_bill_item?.item_type === 'consumption'">
        <img [src]="prev_bill_item.gas_meter_read?.photo" width="100%" class="rounded-3 shadow-sm">
      </div>
      <div class="ms-2 w-100" *ngIf="prev_bill_item?.item_type === 'consumption'">
        <table class="table table-sm rounded-2 border-0 mt-2" style="font-size: 0.8em;">
          <tbody>
            <tr class="border-bottom-secondary" > 
              <th>Anterior</th>
              <td scope="col" colspan="2" class="text-end" ></td>
            </tr>
            <tr class="border-bottom-secondary" > 
              <th>Consumo</th>
              <td scope="col" class="text-end" *ngIf="prev_bill_item.gas_meter_read?.consumo_m3">{{prev_bill_item.gas_meter_read?.consumo_m3 | number: '1.2-2'}} M<sup>3</sup></td>
              <td scope="col" class="text-end" *ngIf="!prev_bill_item.gas_meter_read?.consumo_m3">-- M<sup>3</sup></td>
              <td scope="col" class="text-end" *ngIf="prev_bill_item.gas_meter_read?.consumo_lt">{{prev_bill_item.gas_meter_read?.consumo_lt | number: '1.2-2'}} Lts.</td>
              <td scope="col" class="text-end" *ngIf="!prev_bill_item.gas_meter_read?.consumo_lt">-- Lts.</td>
            </tr>
            <tr class="border-bottom-secondary">
              <th class="table-read-column">Lectura</th>
              <td class="text-end" *ngIf="!prev_bill"></td>
              <td class="text-end table-read-column" *ngIf="prev_bill_item.gas_meter_read?.value">
                <button type="button"
                  class="btn btn-link p-0" 
                  (click)="editRead(prev_bill_item.gas_meter_read)"
                >
                <fa-icon [icon]="icons.faEdit"></fa-icon>
                </button> 
                {{prev_bill_item.gas_meter_read?.value}}
              </td>
              <td class="text-end" *ngIf="!prev_bill_item.gas_meter_read?.value_prev">-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="d-flex mt-2" *ngFor="let bill_item of bill?.bill_items">
      <div class="mt-3" style="width: 160px;" *ngIf="bill_item?.item_type === 'consumption'">
        <img [src]="bill_item.gas_meter_read?.photo" width="100%" class="rounded-3 shadow-sm">
      </div>
      <div class="ms-2 w-100" *ngIf="bill_item?.item_type === 'consumption'">
        <table class="table table-sm rounded-2 border-0 mt-2" style="font-size: 0.8em;">
          <tbody>
            <tr class="border-bottom-secondary" > 
              <th>Actual</th>
              <td scope="col" colspan="2" class="text-end"></td>
            </tr>
            <tr class="border-bottom-secondary">
              <th>Consumo</th>
              <td scope="col" class="text-end" *ngIf="bill_item.gas_meter_read?.consumo_m3">{{bill_item.gas_meter_read?.consumo_m3| number: '1.2-2'}} M<sup>3</sup></td>
              <td scope="col" class="text-end" *ngIf="!bill_item.gas_meter_read?.consumo_m3">-- M<sup>3</sup></td>
              <td scope="col" class="text-end" *ngIf="bill_item.gas_meter_read?.consumo_lt">{{bill_item.gas_meter_read?.consumo_lt | number: '1.2-2'}} Lts.</td>
              <td scope="col" class="text-end" *ngIf="!bill_item.gas_meter_read?.consumo_lt">-- Lts.</td>
            </tr>
            <tr class="border-bottom-secondary">
              <th class="table-read-column">Lectura</th>
              <td class="text-end" *ngIf="!prev_bill">
                (Ant. {{bill_item.gas_meter_read?.value_prev}})
              </td>
              <td class="text-end table-read-column">
                <button type="button"
                  class="btn btn-link p-0" 
                  (click)="editRead(bill_item.gas_meter_read)"
                >
                <fa-icon [icon]="icons.faEdit"></fa-icon>
                </button> 
                {{bill_item.gas_meter_read?.value}}
              </td>
              <td class="text-end" *ngIf="!bill_item.gas_meter_read?.value_prev">-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <app-modal-edit-gas-meter-read
      [gasMeterRead]="selectedGasMeter"
      (onGasMeterReadUpdated)="updateRead($event)"
    ></app-modal-edit-gas-meter-read>
    
    <!-- div class="row">
      <div class="col-md-12">        
      </div>
    </div -->
  `,
  styleUrls: []
})
export class ReceiptReadsComponent implements OnInit {
  @Input() bill: Bill | null = null;
  @Input() prev_bill: Bill | null = null;
  @Output() updateMeterRead = new EventEmitter<any>();
  @ViewChild(ModalEditGasMeterReadComponent) modalEditGasRead !: ModalEditGasMeterReadComponent;

  selectedGasMeter: any;

  constructor(
    public icons: IconsService
  ) { }

  ngOnInit(): void {}

  editRead(item: any) {
    this.selectedGasMeter = item;
    const modalTemplate: any | undefined = this.modalEditGasRead;
    if (modalTemplate) {
      this.modalEditGasRead.openModal(modalTemplate['modalEditGasRead']);
    }
  }

  updateRead(updatedRead: any) {
    this.updateMeterRead.emit(updatedRead);
    // this.selectedGasMeter = null; // Reset after update
  }

}
